import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { AccessRequired } from 'src/components/AccessRequired'
import { NotFound } from 'src/components/NotFound'

import { SupplyChainLayout } from './layout'
import {
  AppointmentPage,
  ASNListPage,
  ASNPage,
  AuditDiffPage,
  AuditPage,
  AuditListPage,
  BarcodedUnitListPage,
  BarcodedUnitPage,
  BatchListPage,
  BatchPage,
  CarrierListPage,
  CarrierPage,
  ClientListPage,
  ClientPage,
  ClientUserPage,
  ContainerListPage,
  ContainerPage,
  DamagedListPage,
  DamagedPage,

  DockPage,
  DriverListPage,
  DriverPage,
  FacilityListPage,
  FacilityPage,
  FoundListPage,
  LostListPage,
  MarketListPage,
  MarketPage,
  PalletListPage,
  PalletPage,
  PickingPage,
  PlaceListPage,
  PlacePage,
  PreviewLabelPage,
  ProductListPage,
  ProductPage,
  SettingsPage,
  SkuListPage,
  SkuPage,
  SkuThresholdListPage,
} from './pages'
import { FreightRouter } from './freightRoutes'
import { ParcelRouter } from './parcelRoutes'
import { Releases } from './components/releases'

export const SupplyChainRouter = () => {
  return (
    <SupplyChainLayout>
      <Releases />
      <AccessRequired>
        <Switch>
          <Route path="/" exact render={() => {
            window.location.replace('/v2/dashboards/orders-shipments')
            return null
          }} />
          <Route path="/settings" component={SettingsPage} exact />
          <Route path="/warehouse/markets/:guid" component={MarketPage} exact />
          <Route path="/warehouse/markets" component={MarketListPage} exact />
          <Route path="/warehouse/facilities/:guid" component={FacilityPage} exact />
          <Route path="/warehouse/facilities" component={FacilityListPage} exact />
          <Route path="/warehouse/docks/:guid" component={DockPage} exact />
          <Route path="/warehouse/places/:guid" component={PlacePage} exact />
          <Route path="/warehouse/places" component={PlaceListPage} exact />
          <Route path="/warehouse/containers/:guid" component={ContainerPage} exact />
          <Route path="/warehouse/containers" component={ContainerListPage} exact />
          <Route path="/inventory/audits/:guid/places/:placeGuid" component={AuditDiffPage} exact />
          <Route path="/inventory/audits/:guid" component={AuditPage} exact />
          <Route path="/inventory/audits" component={AuditListPage} exact />
          <Route path="/inventory/batches/:guid" component={BatchPage} exact />
          <Route path="/inventory/batches" component={BatchListPage} exact />
          <Route path="/inventory/products/:guid" component={ProductPage} exact />
          <Route path="/inventory/products" component={ProductListPage} exact />
          <Route path="/inventory/skus/:guid" component={SkuPage} exact />
          <Route path="/inventory/skus" component={SkuListPage} exact />
          <Route path="/inventory/sku-thresholds" component={SkuThresholdListPage} exact />
          <Route path="/inventory/pallets/:guid" component={PalletPage} exact />
          <Route path="/inventory/pallets" component={PalletListPage} exact />
          <Route path="/inventory/barcoded-units/:guid" component={BarcodedUnitPage} exact />
          <Route path="/inventory/barcoded-units" component={BarcodedUnitListPage} exact />
          <Route path="/inventory/lost" component={LostListPage} exact />
          <Route path="/inventory/found" component={FoundListPage} exact />
          <Route path="/inventory/damages/:guid" component={DamagedPage} exact />
          <Route path="/inventory/damages" component={DamagedListPage} exact />
          <Route path="/clients/:clientGuid/users/:guid" component={ClientUserPage} exact />
          <Route path="/clients/:guid" component={ClientPage} exact />
          <Route path="/clients" component={ClientListPage} exact />
          <Route path="/scheduling/appointments/:guid" component={AppointmentPage} exact />
          <Route path="/shipping/carriers/:guid" component={CarrierPage} exact />
          <Route path="/shipping/carriers" component={CarrierListPage} exact />
          <Route path="/shipping/drivers/:guid" component={DriverPage} exact />
          <Route path="/shipping/drivers" component={DriverListPage} exact />
          <Route path="/shipping/asn/:guid" component={ASNPage} exact />
          <Route path="/shipping/asn" component={ASNListPage} exact />
          <Route path="/inout/picking" component={PickingPage} exact />
          <Route path="/freight" component={FreightRouter} />
          <Route path="/parcel" component={ParcelRouter} />
<Route path="/preview-label" component={PreviewLabelPage} exact />
          <Route path="*" component={NotFound} />
        </Switch>
      </AccessRequired>
    </SupplyChainLayout>
  )
}
